<div class="qwd-content-bodymain" >
    <div class="qwd-error-code-container">
        <span class="qwd-error-code-shadow"></span>
        <h1 class="qwd-error-code img">
            <img  src="assets/images/time.svg"/>
        </h1>
    </div>
    <h1 class="qwd-message-header">{{mainMessage}}</h1>
    <h2 class="qwd-error-message">{{errorMessage}} </h2>
</div>
